import { AccountUsage } from '@superfunnel/types';
import { useEffect, useState } from 'react';
import { subscribeToUsage } from '../services/UsageService';

/**
 * Hook to subscribe to real-time account usage data.
 *
 * @param accountId - The account ID to get usage for
 * @returns The current usage data, or null if not loaded yet
 */
export function useAccountUsage(
  accountId: string | undefined,
): AccountUsage | null {
  const [usage, setUsage] = useState<AccountUsage | null>(null);

  useEffect(() => {
    if (!accountId) {
      setUsage(null);
      return;
    }

    const unsubscribe = subscribeToUsage(accountId, setUsage);

    return () => {
      unsubscribe();
    };
  }, [accountId]);

  return usage;
}
